import { render, staticRenderFns } from "./ForgotPasswordDetail.vue?vue&type=template&id=80cf4d6c&scoped=true&"
import script from "./ForgotPasswordDetail.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordDetail.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordDetail.vue?vue&type=style&index=0&id=80cf4d6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cf4d6c",
  null
  
)

export default component.exports